// components/firebaseNotifications.jsx
import React, { useEffect } from 'react';
import { onMessage } from 'firebase/messaging';
import { messaging } from './firebase';

const FirebaseNotification = () => {
  useEffect(() => {
    const unsubscribe = onMessage(messaging, (payload) => {
      console.log('💡 Foreground notification received:', payload);

      if (payload?.notification) {
        const { title, body } = payload.notification;
        const {
          address,
          alarmId,
          latitude,
          longitude,
          time,
          type,
        } = payload.data || {};

        // ✅ Optional: Format time
        const formattedTime = time
          ? new Date(time).toLocaleString()
          : 'Unknown time';

        // ✅ You can customize the alert message
        const message = `${body}
        
📍 Address: ${address}
🕒 Time: ${formattedTime}
📌 Lat: ${latitude}, Lng: ${longitude}
🚨 Type: ${type}`;

        // ✅ System alert or your own toast logic
        alert(`📢 ${title}\n\n${message}`);

        // ✅ Or: Call a handler function to show UI, modal, sound alert, etc.
        // handleAlarmNotification({ title, body, address, alarmId, latitude, longitude, time, type });
      }
    });

    return () => unsubscribe();
  }, []);

  return null; // No visual component
};

export default FirebaseNotification;
